import { StepperNavigation, Button } from '@predoc/cow';

interface SelectionFooterProps {
  onPrevious: () => void;
  onNext: () => void;
  showValidationError: boolean;
  disabledNext?: boolean;
  disablePrevious?: boolean;
  errorMessage?: string;
}

export const SelectionFooter = ({
  onPrevious,
  onNext,
  showValidationError,
  disabledNext = false,
  disablePrevious = false,
  errorMessage,
}: SelectionFooterProps) => {
  return (
    <StepperNavigation>
      <Button variant="outline" onClick={onPrevious} disabled={disablePrevious}>
        Previous
      </Button>
      <div className="flex items-center gap-2">
        {showValidationError ? (
          <div className="text-destructive text-sm">
            {errorMessage ?? 'Please fix validation errors.'}
          </div>
        ) : (
          <div className="text-muted-foreground text-sm">
            Select the products and services you need.
          </div>
        )}
        <Button onClick={onNext} disabled={disabledNext}>
          Next
        </Button>
      </div>
    </StepperNavigation>
  );
};
